const helpers = require('./helpers')

module.exports.setUpHotjarScripts = function (hotjarId) {
  const externalSrc = '//static.hotjar.com/c/hotjar-'
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }

  window.hj =
    window.hj ||
    function () {
      ;(window.hj.q = window.hj.q || []).push(arguments)
    }

  window._hjSettings = { hjid: hotjarId, hjsv: 5 }

  const head = document.getElementsByTagName('head')[0]
  const scriptElement = document.createElement('script')
  scriptElement.async = 1
  scriptElement.src =
    externalSrc + window._hjSettings.hjid + '.js?sv=' + window._hjSettings.hjsv

  head.appendChild(scriptElement)
}
